import { useTranslation } from "react-i18next";

import errorSvg from "../../assets/error-404.svg";
import styles from "./error-404.module.scss";

export default function Error404() {
  const { t } = useTranslation();

  return (
    <div className={styles.errorWrapper}>
      <img src={errorSvg} draggable={false} alt="Error" />
      <div>
        <h1>404</h1>
        <h2>{t("not-found")}</h2>
      </div>
    </div>
  );
}
